import { useEffect, useState } from "react";
import api, { formatDate, formatDateTime } from "../../../lib/api";
import { Card } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function Health() {
  const [h, setH] = useState(null); const [errs, setErrs] = useState([]);
  const load = () => { api.get("/governance/health").then((r) => setH(r.data)); api.get("/governance/errors").then((r) => setErrs(r.data)); };
  useEffect(() => { load(); }, []);
  if (!h) return <div className="text-sm text-slate-500">Yükleniyor…</div>;
  const Stat = ({ l, v, t }) => <Card className="p-4 shadow-none border-slate-200"><div className="text-xs text-slate-500">{l}</div><div className="text-xl font-bold mt-1" data-testid={t}>{v}</div></Card>;
  return (
    <div className="space-y-4" data-testid="health-panel">
      {h.warnings.length ? (
        <div className="p-3 rounded border border-amber-200 bg-amber-50 text-sm text-amber-900 space-y-1" data-testid="health-warnings">
          {h.warnings.map((w) => <div key={w} className="flex items-center gap-2"><AlertTriangle className="h-4 w-4" />{w}</div>)}
        </div>
      ) : <div className="p-3 rounded border border-emerald-200 bg-emerald-50 text-sm text-emerald-800 flex items-center gap-2"><CheckCircle2 className="h-4 w-4" />Sistem sağlıklı görünüyor.</div>}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat l="Çalışma süresi" v={`${Math.floor(h.uptime_s / 3600)} sa ${Math.floor((h.uptime_s % 3600) / 60)} dk`} />
        <Stat l="Disk boş alan" v={`${h.disk_free_gb} / ${h.disk_total_gb} GB`} />
        <Stat l="Son yedek" v={h.last_backup_age_h != null ? `${h.last_backup_age_h} sa önce` : "yok"} t="health-last-backup" />
        <Stat l="Hata (24 sa)" v={h.errors_24h} t="health-errors" />
        <Stat l="Çöp kutusunda" v={h.trash_count} />
        <Stat l="Gönderilemeyen mesaj (24 sa)" v={h.outbox_failed_24h} />
        <Stat l="İş kaydı" v={h.collections.service_jobs} />
        <Stat l="Denetim kaydı" v={h.collections.audit_log} />
      </div>
      <Card className="p-4 shadow-none border-slate-200">
        <div className="flex items-center justify-between mb-2"><div className="font-semibold">Son sunucu hataları</div>{errs.length > 0 && <Button size="sm" variant="outline" onClick={async () => { await api.delete("/governance/errors"); toast.success("Temizlendi"); load(); }}>Temizle</Button>}</div>
        {errs.length === 0 ? <div className="text-sm text-slate-500">Kayıtlı hata yok.</div> : (
          <div className="space-y-2 max-h-80 overflow-y-auto">{errs.map((e) => (
            <details key={e.id} className="text-sm border rounded p-2"><summary className="cursor-pointer"><span className="text-slate-500">{formatDateTime(e.at)}</span> · <b>{e.method} {e.path}</b> · {e.error}</summary><pre className="text-[11px] mt-2 whitespace-pre-wrap text-slate-600">{e.trace}</pre></details>
          ))}</div>
        )}
        <p className="text-xs text-slate-500 mt-3">Hata anında bildirim kanalı tanımlıysa (Bildirim Kanalları) size mesaj gider. Sentry kullanmak için sunucuda SENTRY_DSN ortam değişkenini tanımlayın{h.sentry ? " (şu an AÇIK)" : ""}.</p>
      </Card>
    </div>
  );
}
